import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leasePaymentRequestTemplates = [
  {
    id: '-120001',
    language: Language.EN,
    subject: 'Payment request for your lease',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>We invite you to pay {{getPaymentTypeSpelling lease invoiceType}} for the lease at <strong>{{getLeaseMainAddress lease}}</strong>. Please find the details below:</p>
        <ul><li>Account number held by {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Amount: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Remittance information: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if displayOpenBalance}}
        <p>Your current account balance is <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if (shouldShowPaymentProviderPaymentLink lease invoice)}}
        <p>You can pay online here: {{paymentProviderPaymentLinkTag paymentProviderPaymentLink language}}</p>
        <p></p>
        {{/if}}
        {{#if (isMandateActive lease invoice)}}
        <p>As you have set up an automatic payment mandate, we will collect <strong>{{totalAmount}} €</strong> on <strong>{{formatDate invoice.dueDate}}</strong>. No action is required on your part.</p>
        <p></p>
        {{/if}}
        <p>Please find a detailed {{getInvoiceOrPaymentRequest lease}} attached.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* This amount may not be up to date, if your payment has crossed the issue of this one.</p>
        {{/if}}`,
  },
  {
    id: '-120002',
    language: Language.FR,
    subject: 'Demande de paiement pour votre bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Nous vous invitons à payer {{getPaymentTypeSpelling lease invoiceType}} pour le bail sis <strong>{{getLeaseMainAddress lease}}</strong>. Veuillez trouver les détails ci-dessous:</p>
        <ul><li>Numéro de compte au nom de {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Montant: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Communication: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if displayOpenBalance}}
        <p>Votre solde actuel est de <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if (shouldShowPaymentProviderPaymentLink lease invoice)}}
        <p>Vous pouvez payer en ligne ici : {{paymentProviderPaymentLinkTag paymentProviderPaymentLink language}}</p>
        <p></p>
        {{/if}}
        {{#if (isMandateActive lease invoice)}}
        <p>Comme vous avez mis en place un mandat de paiement automatique, nous prélèverons <strong>{{totalAmount}} €</strong> le <strong>{{formatDate invoice.dueDate}}</strong>. Aucune action n'est requise de votre part.</p>
        <p></p>
        {{/if}}
        <p>Veuillez trouver une {{getInvoiceOrPaymentRequest lease}} détaillée en pièce jointe.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Ce montant pourrait ne pas être à jour, si votre paiement à croisé l'émission de la présente.</p>
        {{/if}}
    `,
  },
  {
    id: '-120003',
    language: Language.NL,
    subject: 'Betalingsverzoek voor uw huurovereenkomst',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Wij nodigen u uit om {{getPaymentTypeSpelling lease invoiceType}} te betalen voor de huurovereenkomst op <strong>{{getLeaseMainAddress lease}}</strong>. Zie hieronder de details:</p>
        <ul><li>Rekeningnummer bij {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Bedrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Mededeling: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if displayOpenBalance}}
        <p>Uw huidige rekeningsaldo is: <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if (shouldShowPaymentProviderPaymentLink lease invoice)}}
        <p>U kunt hier online betalen: {{paymentProviderPaymentLinkTag paymentProviderPaymentLink language}}</p>
        <p></p>
        {{/if}}
        {{#if (isMandateActive lease invoice)}}
        <p>Aangezien u een automatisch betaalmandaat heeft ingesteld, zullen wij <strong>{{totalAmount}} €</strong> innen op <strong>{{formatDate invoice.dueDate}}</strong>. U hoeft geen actie te ondernemen.</p>
        <p></p>
        {{/if}}
        <p>Gelieve een gedetailleerde {{getInvoiceOrPaymentRequest lease}} bijgevoegd te vinden.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Het kan zijn dat dit bedrag niet up-to-date is, als uw betaling de uitgifte van deze heeft overschreden.</p>
        {{/if}}
        `,
  },
  {
    id: '-120004',
    language: Language.DE,
    subject: 'Zahlungsanfrage für Ihren Mietvertrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Wir laden Sie ein, {{getPaymentTypeSpelling lease invoiceType}} für den Mietvertrag unter <strong>{{getLeaseMainAddress lease}}</strong> zu zahlen. Nachfolgend finden Sie die Details:</p>
        <ul><li>Kontonummer bei {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Betrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Verwendungszweck: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if displayOpenBalance}}
        <p>Ihr aktueller Kontostand beträgt <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if (shouldShowPaymentProviderPaymentLink lease invoice)}}
        <p>Sie können hier online bezahlen: {{paymentProviderPaymentLinkTag paymentProviderPaymentLink language}}</p>
        <p></p>
        {{/if}}
        {{#if (isMandateActive lease invoice)}}
        <p>Da Sie ein automatisches Lastschriftmandat eingerichtet haben, werden wir <strong>{{totalAmount}} €</strong> am <strong>{{formatDate invoice.dueDate}}</strong> einziehen. Es ist keine Aktion Ihrerseits erforderlich.</p>
        <p></p>
        {{/if}}
        <p>Bitte finden Sie eine detaillierte {{getInvoiceOrPaymentRequest lease}} im Anhang.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Dieser Betrag ist möglicherweise nicht aktuell, falls sich Ihre Zahlung mit der Ausstellung überschnitten hat.</p>
        {{/if}}
        `,
  },
];
